<template>
  <el-dialog
    title="添加二维码"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="80px"
      size="small"
    >
      <el-form-item
        prop="title"
        label="名称"
        :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item
              prop="store_id"
              label="选择门店"
              :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.store_id"
                placeholder="请选择"
        >
          <el-option
                  v-for="item in mdOptions"
                  :key="item.id"
                  :label="item.shop_name"
                  :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
              prop="staff_id"
              label="员工"
                    :rules="[{ required: true, message: '不能为空'}]"
      >
        <el-select
                class="filter-item"
                v-model="form.staff_id"
                placeholder="请选择"
        >
          <el-option
                  v-for="item in ygOptions"
                  :key="item.userId"
                  :label="item.userName"
                  :value="item.userId"

          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        prop="amount"
        label="金额"
      >
        <el-input v-model="form.amount"></el-input>
      </el-form-item>
      <el-form-item
              prop="describes"
              label="描述"
      >
        <el-input v-model="form.describes"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
        >保存</el-button>
        <el-button @click="close">取消</el-button>
      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
import * as userService from "@/api/sys/user";
import * as agentService from "@/api/sys/agent";
import util from '@/libs/util.js'
export default {
  name: "userEditForm",
  props: {
    user: Object,
    value: Boolean
  },
  data() {
    return {
        formEdit: true,
        passwordEdit: true,
      loading: false,
      dialogVisible: false,
        mdOptions: [],
        ygOptions: [],
      form: {
          businessid: "",
          businessname: "",
          sort_id: ""
      }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
      this.$refs.form.resetFields();
        var formData2 = new FormData() // 声明一个FormData对象
        formData2.append("agentid",util.cookies.get('agentid'));
        agentService.getStoreagent(formData2).then(data => {
            this.mdOptions=data;
        });
        agentService.getStoreUser(formData2).then(data => {
            this.ygOptions=data;
        });
      if (this.user.id) {
       // userService.getUser(this.user.id).then(data => {
          let form = {};
          form.title = this.user.title;
          form.amount = this.user.amount;
          form.describes = this.user.describes;
          form.store_id = parseInt(this.user.store_id);
          form.staff_id = parseInt(this.user.staff_id);




          this.form = form;
       // });
          this.passwordEdit=false;

      } else {
          this.passwordEdit=true;
        this.form = {};
      }
    },

    saveUser() {
      this.$refs["form"].validate(valid => {
        if (valid) {

                        this.loading = true;
                        userService
                            .saveStoreQrcode({...this.form, id: this.user.id,xt_id: util.cookies.get('xt_id') ,agentid: util.cookies.get('agentid'),amount2:this.user.amount})
                            .then(data => {
                                this.loading = false;
                                this.dialogVisible = false;
                                this.$emit("submit");
                            });

        } else {
          return false;
        }
      });
    },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

